module.exports = __webpack_public_path__ + "img/antes_despues_34.74dfe042.png";